import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { isProvenByData } from "@/lib/page-performance.server";
import { isHighDemandModel } from "@/lib/demand-index.server";

/**
 * Does recorded Search Console performance justify indexing this URL?
 * Called from route loaders so head() can decide synchronously.
 */
export const getIsProvenPage = createServerFn({ method: "GET" })
  .inputValidator((data) => z.object({ path: z.string() }).parse(data))
  .handler(({ data }) => isProvenByData(data.path));

/**
 * Does this nameplate clear the model-level demand threshold? Route loaders
 * pass the answer to head() so the live robots tag matches the sitemap.
 */
export const getIsHighDemandModel = createServerFn({ method: "GET" })
  .inputValidator((data) =>
    z.object({ makeSlug: z.string(), modelSlug: z.string() }).parse(data),
  )
  .handler(({ data }) => isHighDemandModel(data.makeSlug, data.modelSlug));
